import React from 'react';
import Pesaje from '../../components/balanza/Pesaje';
import { PageWrapper } from '../../components/common';

const PesajePage: React.FC = () => {
  return (
    <PageWrapper>
      <Pesaje />
    </PageWrapper>
  );
};

export default PesajePage;